import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { setTransport } from './api/client';
import { Providers } from './app/providers';
import { router } from './app/router';
import './i18n';
import './styles/globals.css';

async function start() {
  // Gate on the env flag (not `apiMode`) so Vite DCE drops this chunk from live builds.
  if (import.meta.env.VITE_API_MODE === 'mock') {
    const { mockTransport } = await import('./api/mock/transport');
    setTransport(mockTransport);
  }

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <Providers>
        <RouterProvider router={router} />
      </Providers>
    </StrictMode>,
  );
}

void start();
